import service from '@/utils/server';

const modName = '/tms/workOrder/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

//详情
export const detail = data => {
  return service({
    url: modName + 'detail/' + data,
    method: 'post',
    data
  });
};
//订单轨迹查询
export const orderTrajectory = data => {
  return service({
    url: modName + 'orderTrajectory',
    method: 'post',
    data
  });
};

//删除订单
export const deleteData = data => {
  return service({
    url: modName + 'deleteData',
    method: 'post',
    data
  });
};

//删除订单
export const initEdit = data => {
  return service({
    url: modName + 'initEdit',
    method: 'post',
    data
  });
};

//修改运输方式
export const editTransType = data => {
  return service({
    url: modName + 'editTransType',
    method: 'post',
    data
  });
};

//修改要求到达时间
export const editReqArriverDate = data => {
  return service({
    url: modName + 'editReqArriverDate',
    method: 'post',
    data
  });
};

//加急
export const orderUrgent = data => {
  return service({
    url: modName + 'orderUrgent',
    method: 'post',
    data
  });
};
//修改项目
export const editProject = data => {
  return service({
    url: modName + 'editProject',
    method: 'post',
    data
  });
};

//模板下载
export const downloadTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data,
    method: 'post',
    data
  });
};

//导入数据
export const importForEditProject = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importForEditProject',
    method: 'post',
    data
  });
};

//订单跟踪
export const getOrderTrace = data => {
  return service({
    url: modName + 'getOrderTrace/' + data,
    method: 'post',
    data
  });
};

//下载文件
export const downloadFile = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: '/common/web/download/file/' + data,
    method: 'post',
    data
  });
}

//详情
export const detailByCustomerOrderNo = data => {
  return service({
    url: modName + 'detailByCustomerOrderNo/' + data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/order/orderSearch/api/index.js